import { useEffect, useState } from 'react'
import StoryBlokService from '../services/StoryBlokService';

const useStoryBlok = () => {
  const [storyBlok, setStoryBlok] = useState<{ data: any }>();
  const [recall, setRecall] = useState<boolean>(false);

  const getStoryBlokConfig = async (fileSlug: string = 'regras-gerais') => {
    try {
      const response = await StoryBlokService.getConfig(fileSlug);
      setStoryBlok(response as typeof storyBlok);
    } catch (error) {
      console.error('Erro ao obter dados do storyblok:', error);
    }
  }

  useEffect(() => {
    getStoryBlokConfig()
  }, [recall]);

  return {
    storyBlok,
    recall: () => setRecall(prevState => !prevState)
  }
}

export default useStoryBlok